import React from "react";
import ReactDOM from "react-dom";
import {Provider} from "react-redux";
import {IntlProvider} from "react-intl";

import store from "./redux/";
import App from "./App";

import translations from "./i18n/locales"

import "semantic-ui-css/semantic.min.css";
import "./assets/css/style.css";
import {BrowserRouter} from 'react-router-dom';

const locale = localStorage.getItem('_LOCALE');
const messages = translations[locale];

if ('serviceWorker' in navigator) {
    console.log('service ok');

    // navigator.serviceWorker
    //     .register('/sw2.js')
    //     .then(function() { console.log('Service Worker Registered'); });

    navigator.serviceWorker.getRegistrations().then(function (registrations) {
        for (let registration of registrations) {

            console.log('unregister', registration);

            registration.unregister();
        }
    });
}

// caches.delete('video-store');

ReactDOM.render(
    <Provider store={store()}>
        <IntlProvider locale={'pt'} messages={messages}>
            <BrowserRouter>
                <App/>
            </BrowserRouter>
        </IntlProvider>
    </Provider>,
    document.getElementById("root")
);